import React from 'react';
import ReactDOM from 'react-dom/client';
//import { createRoot } from 'react-dom/client';
import './index.css';
import './modal.css';
import App from './App';
import { VisitorProvider } from './pages/register-visitor/VisitorContext.jsx'

// Replacing this snippet since I am adding context to be availlable throughout the app
//ReactDOM.render(<App />, document.getElementById('root'));

const rootElement = document.getElementById("root");

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <VisitorProvider>
      <App />
    </VisitorProvider>
  </React.StrictMode>,
)
